module.exports = __webpack_public_path__ + "img/xl-logo.83d28cb7.png";